import {useState}                       from 'react';  
import {    Show, Hide, Delete, 
            Cancel, EditButton, Save}     
                                        from '../../lib/iprs-react-library/src/index.js';
                                        
import {TwoSwitch}                      from '../../lib/iprs-react-library/src/index.js';

const TemplateLink = ({id, name, isHidden, active, deleteTemplate, 
    handleSelectTemplate, toggleHidden, saveTemplateName}) => {
        
    const [confirm, setConfirm]             = useState( false );
    
    const [editingName, setEditingName]     = useState( false );
    const [editName, setEditName]           = useState( name );

    const showHideToggle = e => toggleHidden( id );

    const showHideBtn = isHidden? 
        <Hide onClick={showHideToggle} title='Show template' />:
        <Show onClick={showHideToggle} title='Hide template' />;
    
    const handleEditClick = e => {
        setEditName( name? name: 'enter template name' );
        
        setEditingName(true);
    }
    
    const endEdit = () => {
        
        if( editName.trim() ){
            saveTemplateName( id, editName.trim() );
        
            setEditName('');
            setEditingName(false);
        }
    }
    
    return <li key={id} className={'sideMenuLink ' + (active? 'active': '') } >
    
        <TwoSwitch test={confirm} >
            <ConfirmDelete props={{id, name, setConfirm, deleteTemplate}} />
            <>
                <TwoSwitch test={editingName} >
                    <input value={editName} onChange={e=>setEditName(e.target.value)} 
                            onBlur={endEdit} className='sideMenuLink-edit' />
                    <a href='.'  onClick={handleSelectTemplate} 
                        name={id} className='sideMenuLink-anchor' >{name}</a>
                </TwoSwitch>
                <div className='sideMenuButtons'>
                    {!editingName? <EditButton onClick={handleEditClick} title='Edit template name'/>: 
                            <Save onClick={endEdit} title='Save template name' /> }
                    {showHideBtn}
                    <Delete     onClick={e=>setConfirm(true)} value={id} title='Delete template' />
                </div>
            </>
        </TwoSwitch>
    </li>
};

const ConfirmDelete = ({props: {id, name, setConfirm, deleteTemplate}}) => {

    return <>
        <p className='sideMenuLink-anchor'>Confirm delete template '{name}' for everyone</p>
        <Delete okText='Delete'  onClick={e=>deleteTemplate(id)} title='Confirm delete' />
        <Cancel  onCancel={e=>setConfirm(false)} className='-' />
    </>
}

export default              TemplateLink;